import { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs,
  IconButton,
  Link,
  Tooltip,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import {
  SETTING_API_03,
  SETTING_API_09,
} from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import { externalpostApi } from "../../services/externalApis";
import { useLocation } from "react-router-dom";
import SystemAlert from "../../components/common/SystemAlert";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Divider } from "@mui/material";
function CreateDocumentTypes() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const { LOCCODE, STAFFMAPLOCODE, RESTCODE, USERNAME, COMPCODE } =
    SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";
  const { selectedDoccatcode, selectedDoccatname } = location.state || {};
  // const [selectedreasoncatcode, setSelectedreasoncatcode] = useState("");
  const [datadoccat, setDatadoccat] = useState(null);
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    doctype: "",
    descrip: "",
    doccatcode: "",
    docsavecode: "",
  });

  const [items, setItems] = useState([]);
  console.log("Selected Doccatcode:", selectedDoccatcode);

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        doctype: selectedItem.doctype,

        doccatcode: selectedDoccatcode,
        doctypecode: selectedItem.doctypecode,
        docsavecode: selectedItem.docsavecode,
      });
    }
  }, [selectedItem]);

  console.log("Selected Item Details:", selectedItemDetails);

  useEffect(() => {
    setPageData({
      title: "Document Types",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const goBackToView = () => {
    navigate("/vcreatedocumenttypes");
  };

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }

    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const cleanInputValue = (name, value) => {
    if (typeof value !== "string") return value;

    // Example: clean leading spaces for all inputs, or per field if needed
    return value.replace(/^\s+/, ""); // remove leading spaces
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Auto-clean the input (remove leading spaces)
    const cleanedValue = cleanInputValue(name, value);
    const trimmedValue =
      typeof cleanedValue === "string" ? cleanedValue.trim() : cleanedValue;

    // Prevent initial space only (optional after clean)
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof cleanedValue === "string" && cleanedValue.length > 30) {
      setError((prevErrors) => ({
        ...prevErrors,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }

    // Validate empty or space-only input
    if (typeof cleanedValue === "string" && trimmedValue === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }

    // Always update with the cleaned value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: cleanedValue,
    }));
  };
  const handleInputChangecode = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof value === "string" && value.length > 6) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 5 characters.",
      }));
      return;
    }

    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleInputChangedes = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_09, "get", {
          STS: CON_STATUS_ACTIVE,
        });

        setDatadoccat(result);

        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_03, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          doccatcode: selectedDoccatcode,
          STS: CON_STATUS_ACTIVE && "D",
        });

        setData(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedDoccatcode]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const result = await externalgetApi(
          `${SETTING_API_03}/${selectedDoccatcode}`,
          "get",
          { doccatcode: selectedDoccatcode }
        );

        setItems(result);
        console.log("result.....", result);
      } catch (err) {
        setError(err);
        console.error("Fetch error:", err);
      } finally {
        setIsLoading(false);
      }
    };

    if (selectedDoccatcode) {
      fetchData();
    }
  }, [selectedDoccatcode]);

  const handleCancel = () => {
    setSelectedItemDetails({
      doctype: "",
      descrip: "",
      docsavecode: "",
    });
  };

const handleConfirmClick = async () => {
  setIsButtonDisabled(true);
  const { doctype, docsavecode } = selectedItemDetails;

  //  Required field validation
  const requiredFields = [
    { name: "doccatname", value: selectedDoccatcode, label: "Document Category" },
    { name: "doctype", value: doctype, label: "Document Name" },
    { name: "docsavecode", value: docsavecode, label: "Save Code" },
  ];

  const missingRequiredFields = requiredFields.filter((field) => !field.value);
  if (missingRequiredFields.length > 0) {
    setError((prev) => ({
      ...prev,
      ...Object.fromEntries(
        missingRequiredFields.map((f) => [f.name, `${f.label} is required.`])
      ),
    }));

    setAlertType("error");
    setAlertMessage("Please fill all required fields.");
    setAlertOpen(true);
    setIsButtonDisabled(false);
    return;
  }

  //  Always fetch latest document list for the selected category
  let currentCategoryDocs = [];
  try {
    const result = await externalgetApi(SETTING_API_03, "get", {
      COMPCODE,
      LOCCODE: STAFFMAPLOCODE,
      doccatcode: selectedDoccatcode,
      STS: CON_STATUS_ACTIVE,
    });
    currentCategoryDocs = Array.isArray(result) ? result : [];
  } catch (err) {
    console.error("Error fetching for duplicate check:", err);
  }

  //  Proper duplicate detection (case-insensitive)
  const isDuplicate = currentCategoryDocs.some((item) => {
    const sameName =
      item.doctype?.trim().toLowerCase() === doctype?.trim().toLowerCase();
    // const sameCode =
    //   item.docsavecode?.trim().toLowerCase() ===
    //   docsavecode?.trim().toLowerCase();
    const sameCategory =
      String(item.doccatcode) === String(selectedDoccatcode);

    const notSameRecord =
      !isEdit || item.doctypecode !== selectedItemDetails.doctypecode;

    return notSameRecord && sameCategory && (sameName );
  });

  if (isDuplicate) {
    setAlertType("warning");
    setAlertMessage("Document type name already exists in this category.");
    setAlertOpen(true);
    setIsButtonDisabled(false);
    return;
  }

  //  Prepare payload
  const BRAND_CODE = selectedItem ? selectedItem.doctypecode : 0;

  const payload = {
    ...selectedItemDetails,
    COMPCODE,
    LOCCODE: STAFFMAPLOCODE,
    doccatcode: parseInt(selectedDoccatcode, 10),
    doctypecode: BRAND_CODE,
    STS: CON_STATUS_ACTIVE,
    ENUSER: USERNAME,
  };

  try {
    const response = await externalpostApi(SETTING_API_03, payload);
    console.log("Saved:", response);

    setAlertType("success");
    setAlertMessage(isEdit ? "Updated Successfully!" : "Created Successfully!");
    setAlertOpen(true);

    setSelectedItemDetails({
      doctype: "",
      descrip: "",
      docsavecode: "",
    });

    // setTimeout(() => {
    //   navigate("/vcreatedocumenttypes");
    // }, 1500);
  } catch (error) {
    console.error("Save error:", error);
    setAlertType("error");
    setAlertMessage("An unexpected error occurred.");
    setAlertOpen(true);
  } finally {
    setIsButtonDisabled(false);
  }
};


  const isDescripInList = items.some(
    (item) =>
      item.doctype?.trim().toLowerCase() ===
      selectedItemDetails.doctype?.trim().toLowerCase()
  );

  return (
    <>
      <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to Document Types " arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
            onClick={goBackToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip>
        <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
            Settings
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
             {isEdit ? "Edit Document Type" : "Create Document Type"}
          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 8, sm: 10, md: 10, lg: 10, xl: 10 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {isEdit ? "Edit Document Type" : "Create Document Type"} :{" "}
                {selectedDoccatname}
              </Typography>
            </Grid>
          </Grid>
        </AppBar>

        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={styles.add_form_page_container}
        >
          <Grid
            container
            spacing={2}
            sx={styles.add_form_page_grid_container}
            alignItems="stretch"
          >
            {/* Left Section */}
            <Grid
              item
              size={{ xs: 12, sm: 6, md: 5, lg: 5, xl: 5 }}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <Typography sx={styles.appbar_title}>
                Documents Types List
              </Typography>
              <List
                dense
                sx={{ p: 0, mt: 2, maxHeight: 400, overflow: "auto" }}
              >
                {items.map((item) => (
                  <ListItem
                    key={item.id}
                    sx={{
                      borderRadius: 2,
                      boxShadow: "0px 1px 5px rgba(0,0,0,0.1)",
                      mb: 1,
                      bgcolor: "#fff",
                      "&:hover": {
                        bgcolor: "#f5f5f5",
                      },
                      px: 2,
                      py: 1.5,
                    }}
                  >
                    <ListItemText
                      primary={item.doctype}
                      primaryTypographyProps={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#333",
                      }}
                    />
                    <ListItemSecondaryAction>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<AddCircleOutlineIcon />}
                        sx={{
                          bgcolor: "#1976d2",
                          "&:hover": { bgcolor: "#115293" },
                          textTransform: "none",
                        }}
                        onClick={() =>
                          setSelectedItemDetails((prevDetails) => ({
                            ...prevDetails,
                            doctype: item.doctype, // Set the text field
                            docsavecode: item.docsavecode, // Set the text field
                          }))
                        }
                      >
                        Add
                      </Button>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            </Grid>

            {/* Vertical Divider */}
            <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />

            {/* Right Section */}

            <Grid
              item
              size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <TextField
                id="description"
                label=" Document  Category"
                variant="outlined"
                fullWidth
                required
                size="small"
                name="doccatname"
                value={selectedDoccatname}
                disabled
                // onChange={handleInputChange}
                // error={!!error.descrip}
                sx={{ mt: 2 }} // <-- Added margin top
                // helperText={error.descrip}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" },
                }}
              />

              <TextField
                id="description"
                label="Document Type Name"
                variant="outlined"
                fullWidth
                required
                size="small"
                name="doctype"
                value={selectedItemDetails.doctype}
                onChange={handleInputChange}
                error={!!error.doctype}
                sx={{ mt: 2 }}
                helperText={error.doctype}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" },
                }}
                disabled={isDescripInList}
              />

              <TextField
                id="description"
                label="Save Code"
                variant="outlined"
                fullWidth
                required
                size="small"
                name="docsavecode"
                value={selectedItemDetails.docsavecode}
                onChange={handleInputChange}
                error={!!error.docsavecode}
                sx={{ mt: 2 }}
                helperText={error.docsavecode}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" },
                }}
                disabled={isDescripInList}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
            onClick={handleCancel}
            disabled={isButtonDisabled}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
            onClick={handleConfirmClick}
            disabled={isButtonDisabled}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Box>

        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
    </>
  );
}

export default CreateDocumentTypes;
